import React from "react";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { adminRoutes } from "../../common/constants";
import { MdLogout } from "react-icons/md";
import { useLogOut } from "../../../utils/helpers";

const SideDrawer = ({ isOpen, onClose }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const logout = useLogOut();
  const check = (i, item) => {
    const isTrue =
      i !== 5 ? pathname.includes(item.path) : pathname.includes("/settings");
    return isTrue;
  };

  return (
    <Drawer
      autoFocus={false}
      isOpen={isOpen}
      placement="right"
      size={["full", "full", "full", "full"]}
      onClose={onClose}
    >
      <DrawerOverlay />
      <DrawerContent bgColor="#fff" color="#000">
        <DrawerBody p={0} overflowY="scroll">
          <Flex h="100vh" flexDir="column">
            <Flex
              pos="sticky"
              px="24px"
              top="0"
              bg="#fff"
              zIndex={555}
              py="20px"
              justifyContent="space-between"
              align="center"
            >
              <Box>
                <Image
                  src="/assets/logo.png"
                  w={{ base: "100px", lg: "100px" }}
                  h={{ base: "40px", lg: "60px" }}
                />
              </Box>
              <Box
                border="1px solid #E0E0E0"
                cursor="pointer"
                _hover={{ boxShadow: "lg" }}
                bg="#f2f2f2"
                onClick={onClose}
                rounded="full"
                p="2"
              >
                <AiOutlineClose />
              </Box>
            </Flex>

            <Box pt="40px" px="24px">
              {adminRoutes?.map((item, i) => {
                return (
                  <VStack
                    key={i}
                    align="stretch"
                    className={!check(i, item) && "parent_nav"}
                  >
                    <Flex
                      align="center"
                      p={2}
                      py="10px"
                      pl="16px"
                      pr="2px"
                      mb="12px"
                      fontSize="13px"
                      lineHeight="100%"
                      cursor="pointer"
                      onClick={() => (navigate(item.path), onClose())}
                      bg={check(i, item) ? "#01ACF0" : "transparent"}
                      color={check(i, item) ? "#fff" : "#B3B9C4"}
                      fontWeight={500}
                      _hover={{
                        bg: check(i, item) ? "" : "transparent",
                        color: check(i, item) ? "" : "#EE383A",
                      }}
                      borderRadius={4}
                      position="relative"
                    >
                      <Box className="hovered_image">{item.sec}</Box>

                      <Box className="initial_image" w="20px" h="20px">
                        {check(i, item) ? item.sec : item.icon}
                      </Box>
                      <Box>
                        <Text ml="8px">{item.name}</Text>
                      </Box>

                      {check(i, item) && (
                        <Box
                          position="absolute"
                          top="50%"
                          right={2}
                          transform="translateY(-50%)"
                          w="3px"
                          h="28px"
                          bg="#fff"
                          borderRadius={4}
                        />
                      )}
                    </Flex>
                  </VStack>
                );
              })}
            </Box>
            <Flex onClick={logout} align="center" px="40px" gap={4}>
              <Box className="initial_image" w="20px" h="20px">
                <MdLogout size={30} fill="#080761" />
              </Box>
              <Text pt="2px">Logout</Text>
            </Flex>

            <Flex
              mt="auto"
              pt="20px"
              bg="#fff"
              zIndex={55}
              mb="39px"
              pos="sticky"
              bottom="0"
              flexDir="column"
              justifyContent="center"
              align="center"
            >
              <Text fontSize="12px" color="#000" lineHeight="100%" mb="8px">
                Powered by {""}
                <span style={{ color: "red" }}>Fazo</span>
              </Text>
            </Flex>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default SideDrawer;
